// ABOUTME: Context and hook for tracking form submission state and unsaved changes warnings
// ABOUTME: Used to prevent navigation when form has unsaved changes; the provider lives in WatchConfirmSubmitProvider.tsx

import type { Dispatch, SetStateAction } from "react"
import { createContext, useContext } from "react"

export interface WatchConfirmState {
  isConfirmChange: boolean
  isSubmit: boolean
  isDontSave: boolean
  /** URL to navigate to after successful save */
  pendingNavigationUrl: string | null
}

export interface WatchConfirmSubmitContextProps {
  watchConfirm: WatchConfirmState
  setWatchConfirm: Dispatch<SetStateAction<WatchConfirmState>>
}

export const WatchConfirmSubmitContext = createContext<WatchConfirmSubmitContextProps | undefined>(undefined)

export const useWatchConfirmSubmitContext = () => {
  const context = useContext(WatchConfirmSubmitContext)
  if (!context) {
    throw new Error("useWatchConfirmSubmitContext must be used within a WatchConfirmSubmitProvider")
  }
  return context
}

export default WatchConfirmSubmitContext
